import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchHome } from "../services/api";

export const homeData = createAsyncThunk(
  "homeData",
  async (_, { rejectWithValue }) => {
    try {
      return await fetchHome();
    } catch (error) {
      return rejectWithValue(error.message || "Failed to load home");
    }
  }
);

const HomeSlice = createSlice({
  name: "homeReducer",
  initialState: {
    isLoading: false,
    data: null,
    error: null,
  },
  reducers: {
    clearHomeData: (state) => {
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(homeData.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(homeData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(homeData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to load home";
      });
  },
});

export const { clearHomeData } = HomeSlice.actions;
export default HomeSlice.reducer;
